// Import sentry first to ensure it's initialized before any other imports
// eslint-disable-next-line import/order
import * as Sentry from '@sentry/react';
Sentry.init({
  dsn: 'https://4d928c2d2ed6ebb13ff604872015d281@o225462.ingest.us.sentry.io/4510002042241024',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './styles/globals.css';
import './styles/iframe-preview.css';

// Detect if we're in an iframe and apply appropriate styling
const isInIframe = window.self !== window.top;
const urlParams = new URLSearchParams(window.location.search);
const hasIframeParam = urlParams.has('iframe');

if (isInIframe || hasIframeParam) {
  document.documentElement.setAttribute('data-iframe', 'true');
  document.body.setAttribute('data-iframe', 'true');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
